import {fetchBody, URL_CUSTOMERPOSITION_GET_LIST, URL_CUSTOMERPOSITION_ADD, URL_CUSTOMERPOSITION_GET_DETAIL, URL_OPENDATA_GET_LABORINSURANCE, URL_OPENDATA_GET_HEALTHINSURANCE} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getLaborInsuranceLevel_Arr ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_OPENDATA_GET_LABORINSURANCE, 
      success,
      failure
    })
  }
}

export function api_getHealthInsuranceLevel_Arr ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_OPENDATA_GET_HEALTHINSURANCE, 
      success,
      failure
    })
  }
}
